module.exports = __webpack_public_path__ + "img/_54A2242.3b7fb2c8.jpg";